module.exports = __webpack_public_path__ + "img/Burgers.8622a6a0.svg";